<template>
  <div class="relative">
    <div v-if="loadingStore.isLoading" class="overlay" data-testid="loading-spinner">
      <ProgressSpinner fill="transparent" aria-label="Loading..." />
    </div>
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import { useLoadingStore } from '@/stores/loading';

const loadingStore = useLoadingStore();
</script>

<style lang="css">
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10; /* Adjust as needed */
}
</style>
